// /components/Style/CommonStyle.js

// 「ゲームのせつめい」見出し用の共通スタイル
export const GAME_DESCRIPTION_HEADING_SX = {
  mt: 2,                 // 上の余白
  width: '100%',         // 横幅いっぱい
  display: 'block',      // ブロック要素に
  bgcolor: '#C83031',    // 赤背景（必要ならここを変えればOK）
  color: 'white',        // 文字色：白
  py: 1.2,               // 縦の余白（高さ調整）
  px: 1.5,               // 左右の余白
  borderRadius: '4px',   // 角丸
  fontWeight: 'bold',    // 太字
  fontSize: `20px`, // ← フォントサイズを定数から参照
};